import * as React from 'react'

import { Card, TogglerCheckbox } from '@factorialco/deprecated-design-system'
import type { Field } from 'factorial-form'

import i18n from 'modules/core/lib/i18n'

interface Props {
  field: Field
  onChange: (value: boolean) => void
}

const AttachmentMandatory = ({ field, onChange }: Props) => (
  <Card extra={{ 'data-intercom-target': 'leave-type-attachment-mandatory-input' }}>
    <Card.Title size="small" action={<TogglerCheckbox value={field.value} onChange={onChange} />}>
      {i18n.t('settings.leave_types.page.permissions.form.attachment_mandatory.label')}
    </Card.Title>
  </Card>
)

export default AttachmentMandatory
